import React from 'react';
import ImagePicker from '../../../Components/ImagePicker/ImagePicker';

const AuthorEditor = ({ author, onBioChange, onFormChange }) => {
  return (
    <div className="editor-card">
      <h3>Szerzői Bemutatkozás</h3>
      <div className="form-group">
        <label>Név</label>
        <input 
          type="text" 
          value={author.name} 
          onChange={(e) => onFormChange('author.name', e.target.value)}
        />
      </div>
      <div className="form-group">
        <label>Bemutatkozás (bekezdések között üres sor)</label>
        <textarea
          rows="15"
          value={author.bio.join('\n\n')}
          onChange={onBioChange}
        />
      </div>
      <ImagePicker 
        label="Profilkép"
        value={author.profileImage}
        onChange={(newValue) => onFormChange('author.profileImage', newValue)}
      />
    </div>
  );
};

export default AuthorEditor;